import { flow, Instance, types, getParent } from 'mobx-state-tree';
import { DateTime } from 'luxon';

import { removeMeetSlot } from '@common/api/meetSlots';

import { IReworkingSlotsModel } from './ReworkingSlots';

const ReworkingSlot = types
	.model('ReworkingSlot',
	{
		id: types.identifierNumber,
		location: types.frozen(),
		service_id: types.number,
		student_id: types.maybeNull(types.number),
		parent_id: types.maybeNull(types.number),
		end_dt: types.string,
		start_dt: types.string,
		status: types.maybeNull(types.number),
		teacher: types.maybeNull(types.frozen()),
		type: types.enumeration('Type', ['appointment', 'working_off']),
	})
	.views((self) => ({
		get startDateTime() {
			return DateTime.fromSQL(self.start_dt);
		},
		get endDateTime() {
			return DateTime.fromSQL(self.end_dt);
		},
	}))
	.views((self) => ({
		get weekday(): number {
			return self.startDateTime.weekday;
		},
		get hourNumber(): number {
			return self.startDateTime.hour;
		},
		get hourSlotNumber(): number {
			const parent = getParent(self, 2) as IReworkingSlotsModel;
			return Math.floor(self.startDateTime.minute / parent.slotDuration);
		},
		get timesString() {
			return `${self.startDateTime.toLocaleString(DateTime.TIME_24_SIMPLE)} - ${self.endDateTime.toLocaleString(DateTime.TIME_24_SIMPLE)}`;
		},
		get lessonSlotNumber(): number {
			const parent = getParent(self, 2) as IReworkingSlotsModel;
			const shift = parent.minHour * parent.slotsInHour - 1;
			return (self.startDateTime.hour + self.startDateTime.minute / 60) * parent.slotsInHour
				- shift;
		},
		get isOtherLocation(): boolean {
			const parent = getParent(self, 2) as IReworkingSlotsModel;
			return self.location.id !== parent.location_id;
		},
	}))
	.actions((self) => ({
		_fetch: () => {},
		remove: flow(function* () {
			yield removeMeetSlot(self.id);
			const parent = getParent(self, 2) as IReworkingSlotsModel;
			parent.removeSlot(self);
		}),
		setStatus(status: number, studentId?: number, parentId?: number) {
			self.status = status;
			if (studentId || studentId === null) {
				self.student_id = studentId;
			}
			if (parentId || parentId === null) {
				self.parent_id = parentId;
			}
		},
	}));

export default ReworkingSlot;

export interface IReworkingSlotModel extends Instance<typeof ReworkingSlot> {}
